import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/close-teal.svg'


const _withScopeId = n => (_pushScopeId("data-v-28fe2ead"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "the-top-banner"
}

import { onMounted, ref } from 'vue'
import BaseLink from '@/components/BaseLink.vue'
import { linkTo } from '@/constants'

// change this BANNER_ID & LINK when changing an active campaign, so the proper value from local storage is taken

export default /*#__PURE__*/_defineComponent({
  __name: 'TheTopBanner',
  setup(__props) {

const BANNER_ID = 'cryptonative_report'
const LINK = linkTo.cryptonativeReport

const LOCAL_STORAGE_WAS_BANNER_DISPLAYED_KEY = `homepage_app_was_top_banner_displayed--${BANNER_ID}`
const isDisplayed = ref(!localStorage.getItem(LOCAL_STORAGE_WAS_BANNER_DISPLAYED_KEY))

const handleCloseClick = () => {
  isDisplayed.value = false
}

onMounted(() => {
  // display banner only once
  window.localStorage.setItem(LOCAL_STORAGE_WAS_BANNER_DISPLAYED_KEY, 'true')
})

return (_ctx: any,_cache: any) => {
  return (isDisplayed.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(BaseLink, {
          to: _unref(LINK),
          target: "_blank",
          color: "teal",
          class: "the-top-banner__text"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Read cryptonative economy report ")
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("img", {
          class: "the-top-banner__close-icon",
          src: _imports_0,
          alt: "close",
          onClick: handleCloseClick
        })
      ]))
    : _createCommentVNode("", true)
}
}

})